import { render, staticRenderFns } from "./Mymodel.vue?vue&type=template&id=1f93e122&scoped=true&"
import script from "./Mymodel.vue?vue&type=script&lang=js&"
export * from "./Mymodel.vue?vue&type=script&lang=js&"
import style0 from "./Mymodel.vue?vue&type=style&index=0&id=1f93e122&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93e122",
  null
  
)

export default component.exports